/**
 * Shop the Look JavaScript for Shopify
 * Version 2.0 - Supporto layout multipli
 * Gestisce click su ogni look individuale
 */

document.addEventListener('DOMContentLoaded', function () {
    const lookItems = document.querySelectorAll('.shop-the-look-item');

    lookItems.forEach(item => {
        const button = item.querySelector('.shop-the-look-button');
        const products = item.querySelector('.shop-the-look-products');
        
        if (!products || !button) return;

        // Funzione per aprire/chiudere i prodotti
        function toggleProducts(event) {
            // Previeni la propagazione se si clicca sui prodotti
            if (products.contains(event.target)) {
                event.stopPropagation();
                return;
            }

            const isVisible = products.classList.contains('visible');

            if (isVisible) {
                // Chiudi
                products.classList.remove('visible');
                item.classList.remove('blurred');
                setTimeout(() => {
                    products.style.display = 'none';
                }, 500);
            } else {
                // Apri
                products.style.display = 'grid';
                // Forza reflow per triggerare animazione
                void products.offsetWidth;
                setTimeout(() => {
                    products.classList.add('visible');
                    item.classList.add('blurred');
                }, 10);
            }
        }

        // Click su tutto il look item
        item.addEventListener('click', function(event) {
            // Ignora click sui prodotti
            if (products.contains(event.target)) {
                return;
            }
            toggleProducts(event);
        });

        // Click specifico sul pulsante
        button.addEventListener('click', function(event) {
            event.stopPropagation();
            toggleProducts(event);
        });

        // Chiudi quando si clicca fuori (opzionale)
        document.addEventListener('click', function(event) {
            if (!item.contains(event.target) && products.classList.contains('visible')) {
                products.classList.remove('visible');
                item.classList.remove('blurred');
                setTimeout(() => {
                    products.style.display = 'none';
                }, 500);
            }
        });
    });
});
